import { formatTargetSipLabel } from '../../../../display-values/sipPlanAmount'
import { useBottomSheet } from '../../../../../../../state-management/contexts/BottomSheetContext'
import {
  isSipIdealPlansFetchFailed,
  isSipIdealPlansLoading,
  useSipPlansContext
} from '../../SipPlansProvider'
import { SipPlanMode } from '../../../api/types'
import { SipEditIdealSipBottomSheet } from './SipEditIdealSipBottomSheet'
import { isSipIdealPlansListFullyEmpty } from '../../../../utils/sip/planListUtils'
import { EventNames } from '../../../../../../../types/misc.types'
import { lightImpactVibrate, trackEvent } from '../../../../../../../utils/appBridge'
import { PlansScreen, PlansSipListEventIds } from '../../../../analytics/plansEvents'
import {
  getPlansFlowTheme,
  PlansThemeFlow
} from '../../../../lumpsum/plans-list/header/common/riskProfileHeaderTheme'

export const SIP_IDEAL_CONTEXT_CLASS_NAME = 'relative z-[1] pt-[18px] px-5 pb-6'

export function SipIdealContextBar() {
  const { plansOverview, derivedPlans, plansQuery, submitIdealSipAmount } = useSipPlansContext()
  const isHeaderLoading = isSipIdealPlansLoading(
    SipPlanMode.IDEAL_SIPS,
    plansOverview != null,
    plansQuery
  )
  const isPlansEmpty =
    !isHeaderLoading && isSipIdealPlansListFullyEmpty(derivedPlans?.idealCategories)
  const isPlansFetchFailed = isSipIdealPlansFetchFailed(SipPlanMode.IDEAL_SIPS, plansQuery)
  const totalIdealSipAmount = plansOverview?.totalIdealSipAmount ?? 0
  const { openBottomSheet, closeBottomSheet } = useBottomSheet()

  if (isHeaderLoading || isPlansEmpty || isPlansFetchFailed || totalIdealSipAmount <= 0) {
    return null
  }

  function handleEditIdealSipClick() {
    lightImpactVibrate()
    trackEvent({
      eventName: EventNames.UserClicked,
      payload: {
        ScreenName: PlansScreen.SipIdeal,
        eventId: PlansSipListEventIds.EditIdealSip,
        buttonLabel: 'Edit'
      }
    })
    openBottomSheet(
      <SipEditIdealSipBottomSheet
        initialAmount={totalIdealSipAmount}
        minSipValue={plansOverview?.minSipValue ?? 0}
        maxSipValue={plansOverview?.maxSipValue ?? 0}
        onDismiss={closeBottomSheet}
        onConfirm={(nextTotalIdealSipAmount) => {
          closeBottomSheet()
          submitIdealSipAmount(nextTotalIdealSipAmount)
        }}
      />
    )
  }

  return (
    <div className={SIP_IDEAL_CONTEXT_CLASS_NAME} data-sip-plans-ideal-context>
      <div className="text-[13px] leading-[150%] text-[#6A6E6E]">
        Below plan is as per {' '}
        <span className="font-[500] text-[#232323]">
          SIPs of {formatTargetSipLabel({ rawAmount: totalIdealSipAmount })}/mo
        </span>{' '}
        <div
          className={`inline font-[500] underline cursor-pointer ${getPlansFlowTheme(PlansThemeFlow.SIP_IDEAL).primaryTextClassName}`}
          onClick={handleEditIdealSipClick}
        >
          Edit
        </div>
      </div>
    </div>
  )
}
